export default "__VITE_ASSET__42aa0fb2__"